import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');
    setLoading(true);
    try {
      // #269 (2026-10-29): never call the identifier-lookup endpoint here (it was an account-existence oracle on the reset
      // page). Always post the reset request and show the same message; an SSO hint, if any, goes into the
      // email sent to a real account holder.
      // Send reset email
      await axios.post(`${config.API_BASE_URL}/auth/forgot-password`, { email: email.trim().toLowerCase() });
      setDone(true);
    } catch (err) {
      setError(err?.response?.status === 429
        ? 'Too many attempts. Please wait and try again.'
        : 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white rounded-xl shadow p-8 max-w-md w-full text-center">
          <div className="text-4xl mb-4">??</div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">Check Your Email</h2>
          <p className="text-gray-500 text-sm mb-6">
            If an account exists for this email, a password reset link has been sent. The link expires in 30 minutes.
          </p>
          <button onClick={() => navigate('/login')} className="text-blue-600 text-sm hover:underline">
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white rounded-xl shadow p-8 max-w-md w-full">
        <div className="mb-6 text-center">
          <div className="text-4xl mb-3">??</div>
          <h2 className="text-2xl font-bold text-gray-900">Forgot Password</h2>
          <p className="text-gray-500 mt-1 text-sm">Enter your email and we will send you a reset link.</p>
        </div>

        {error && (
          <div className="mb-4 bg-red-50 border border-red-200 text-red-700 rounded-lg px-4 py-3 text-sm">{error}</div>
        )}

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            />
          </div>
          <button
            onClick={handleSubmit}
            disabled={loading || !email}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg text-sm transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
          <div className="text-center">
            <button onClick={() => navigate('/login')} className="text-blue-600 text-sm hover:underline">
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
